import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const downloadProjectPDF = (project) => {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text(project.projectTitle || 'Project Details', 14, 20);

  autoTable(doc, {
    startY: 30,
    styles: { fontSize: 10 },
    body: [
      ['Company Name', project.companyName],
      ['Project Summary', project.projectSummary],
      ['Domain', project.domain],
      ['Tech Stack', project.preferredTechStack],
      ['Programming Languages', project.preferredProgrammingLanguages],
      ['Expected Deliverables', project.expectedDeliverables],
      ['Project Duration', project.projectDuration],
      ['Weekly Commitment', project.weeklyTimeCommitment],
      ['Mode of Work', project.modeOfWork],
      ['Compensation', project.compensation],
      ['Confidentiality/IP Clauses', project.confidentialityOrIPClauses],
      ['Start Date', project.desiredStartDate ? new Date(project.desiredStartDate).toLocaleDateString() : 'N/A'],
      ['Deadline', project.applicationDeadline ? new Date(project.applicationDeadline).toLocaleDateString() : 'N/A'],
      ['Status', project.status],
      ['Contact Name', project.pointOfContact?.name],
      ['Contact Designation', project.pointOfContact?.designation],
      ['Contact Email', project.pointOfContact?.email],
      ['Contact Phone', project.pointOfContact?.phoneNumber]
    ]
  });

  doc.save(`${project.projectTitle?.replace(/\s+/g, '_') || 'project'}_details.pdf`);
};
